import { useEffect, useRef } from 'react';

import Image from 'next/image';

import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon } from '@assets/icons';
import { HotelEventsViewModel } from '@api/index';
import { Typography } from '@components/Typography';
import Markdown from '@components/utils/Markdown';

import {
  ContentWrapper,
  DescriptionBox,
  Header,
  ImageScrollContainer,
  ImageWrapper,
  Main,
  ModalWrapper,
  TitleWrapper,
  Wrapper,
  MobileImageWrapper,
} from './styled';

type Props = Partial<HotelEventsViewModel> & {
  toggleKrokiModal: () => void;
};

const EventKrokiModal = ({
  title,
  image,
  toggleKrokiModal,
  description,
}: Props) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Center the scroll position on mount
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const centerPosition = (scrollWidth - clientWidth) / 2;
      container.scrollLeft = centerPosition;
    }
  }, []);
  const { xl: isDesktop } = useBreakpoint();

  return (
    <ModalWrapper>
      <Wrapper>
        <Header>
          <TitleWrapper>
            <Typography variant='Title4' weight='SemiBold' color='D400'>
              <Markdown text={title} />
            </Typography>
          </TitleWrapper>

          <CustomIcon
            icon={CloseIcon}
            fontSize={24}
            paletteColor='D400'
            clickable
            onClick={toggleKrokiModal}
          />
        </Header>

        <Main>
          <ContentWrapper>
            {description ? (
              <DescriptionBox>
                <Typography variant='caption2' weight='Regular' color='D400'>
                  <Markdown text={description} />
                </Typography>
              </DescriptionBox>
            ) : null}
          </ContentWrapper>
          <ImageScrollContainer ref={scrollContainerRef}>
            {isDesktop ? (
              <ImageWrapper>
                <Image
                  src={image ?? ''}
                  alt={title ?? ''}
                  width={860}
                  height={469}
                />
              </ImageWrapper>
            ) : (
              <MobileImageWrapper>
                <Image
                  src={image ?? ''}
                  alt={title ?? ''}
                  width={860}
                  height={469}
                />
              </MobileImageWrapper>
            )}
          </ImageScrollContainer>
        </Main>
      </Wrapper>
    </ModalWrapper>
  );
};

export default EventKrokiModal;
